export default __webpack_public_path__ + "static/media/data-centralization.fb3f435b.svg";